
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand/[...params]",
      function () {
        return require("private-next-pages/brand/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand/[...params]"])
      });
    }
  